export default __webpack_public_path__ + "static/media/disclaimer-graph.53d12daa.jpg";